// import React, { useEffect, useState } from 'react';
// import { Card, Container, Row, Col, Button, Badge, Modal } from 'react-bootstrap';

// export default function SellerSuccesBids() {
//   const [confirmedBids, setConfirmedBids] = useState([]);
//   const [selectedBuyer, setSelectedBuyer] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const user = JSON.parse(sessionStorage.getItem('user'));
//   const sellerId = user?.id;

//   const handleContactBuyer = (buyer) => {
//     setSelectedBuyer(buyer);
//     setShowModal(true);
//   };

//   useEffect(() => {
//     const fetchConfirmedBids = async () => {
//       try {
//         const res = await fetch(`https://vyaparapi.emedha.in/api/seller/confirmed-bids/${sellerId}`);
//         const data = await res.json();
//         setConfirmedBids(data);
//       } catch (err) {
//         console.error('❌ Error fetching seller confirmed bids:', err);
//       }
//     };

//     if (sellerId) fetchConfirmedBids();
//   }, [sellerId]);

//   if (!sellerId) return <p>Please log in as seller.</p>;

//   return (
//     <Container className="my-5 seller-successful-bids">
//       <h5 className="section-title text-center mb-4" style={{ color: '#062d59', fontSize:'25px' }}>
//         🎯 Seller Confirmed Bids
//       </h5>

//       {confirmedBids.length === 0 ? (
//         <p className="text-center text-muted">No confirmed bids found.</p>
//       ) : (
//         <Row>
//           {confirmedBids.map(({ seller_bid, bid_details, buyer_details }) => (
//             <Col md={4} key={seller_bid.id} className="mb-4">
//               <Card style={{ borderColor: '#062d59' }}>
//                 <Card.Body>
//                   <h5 className="mb-3 text-primary">
//                     <strong>🆔 Bid ID:</strong> {seller_bid.bid_id}
//                   </h5>

//                   <Row className="mb-2">
//                     <Col md={6}>
//                       <strong>📦 Category:</strong> {bid_details.category} / {bid_details.sub_category}
//                     </Col>
//                     <Col md={6}>
//                       <strong>💰 Price Range:</strong> ₹{bid_details.price_from} - ₹{bid_details.price_to}
//                     </Col>
//                   </Row>

//                   <Row>
//                     <Col md={6}>
//                       <strong>🔧 Warranty:</strong> {bid_details.warranty}
//                     </Col>
//                     <Col md={6}>
//                       <strong>🧩 Specs:</strong> {bid_details.selected_specs}
//                     </Col>
//                   </Row>

//                   <p className="text-muted mt-2">
//                     🕒 Created: {new Date(bid_details.created_at).toLocaleString()}
//                   </p>

//                   <h6 className="text-secondary mt-4">Your Offer</h6>
//                  <p>
//   <strong>Offer Price:</strong> ₹{seller_bid.seller_offer} <br />
//   <strong>Status:</strong>{' '}
//   <Badge bg={seller_bid.status === 'accepted' ? 'success' : 'secondary'}>
//     {seller_bid.status}
//   </Badge>{' '}
//   <br />
//   <strong>Accepted At:</strong>{' '}
//   {seller_bid.accepted_at
//     ? new Date(seller_bid.accepted_at).toLocaleString()
//     : 'N/A'}
//   <br />
//   <strong>Paid Amount (10%):</strong> ₹{seller_bid.paid_amount_10per} <br />
//   <strong>Paid Amount (90%):</strong> ₹{seller_bid.paid_amount_90per} <br />
//   <strong>Payment Status:</strong>{' '}
//   <Badge bg={seller_bid.payment_status === 'paid' ? 'success' : 'warning'}>
//     {seller_bid.payment_status}
//   </Badge>{' '}
//   <br />
//   <strong>Final Payment:</strong>{' '}
//   {seller_bid.payment_status === 'paid' && Number(seller_bid.paid_amount_90per) > 0 ? (
//     <Badge bg="success">100% Paid</Badge>
//   ) : (
//     <Badge bg="secondary">Pending</Badge>
//   )}
// </p>

        
//                   <Button variant="danger" size="sm" onClick={() => handleContactBuyer(buyer_details)}>
//                     Contact Buyer
//                   </Button>
//                 </Card.Body>
//               </Card>
//             </Col>
//           ))}
//         </Row>
//       )}

//       <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//         <Modal.Header closeButton style={{ backgroundColor: '#062d59', color: '#fff' }}>
//           <Modal.Title>Buyer Information</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedBuyer && (
//             <>
//               <h5 className="text-primary">{selectedBuyer.name}</h5>
//               <p><strong>Email:</strong> {selectedBuyer.email}</p>
//               <p><strong>Mobile:</strong> {selectedBuyer.mobile}</p>
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// }

import React, { useEffect, useState } from 'react';
import { Card, Container, Row, Col, Button, Badge, Modal } from 'react-bootstrap';
import './SellerSuccesBids.css'; // 👈 You'll need to create this CSS file
import { FaGavel } from 'react-icons/fa';

export default function SellerSuccesBids() {
  const [confirmedBids, setConfirmedBids] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const user = JSON.parse(sessionStorage.getItem('user'));
  const sellerId = user?.id;

  const handleContactBuyer = (buyer) => {
    setSelectedBuyer(buyer);
    setShowModal(true);
  };

  useEffect(() => {
    const fetchConfirmedBids = async () => {
      try {
        const res = await fetch(`https://vyaparapi.emedha.in/api/seller/confirmed-bids/${sellerId}`);
        const data = await res.json();
        setConfirmedBids(data);
      } catch (err) {
        console.error('❌ Error fetching seller confirmed bids:', err);
      }
    };

    if (sellerId) fetchConfirmedBids();
  }, [sellerId]);

  if (!sellerId) return <p className="text-center mt-5 text-danger">Please log in as seller.</p>;

  return (
    <Container className="my-5 seller-successful-bids">
      <h2 className="section-title text-center mb-5 text-gradient">  <FaGavel className="me-2" style={{ color: '#062d59' }} />Seller Confirmed Bids</h2>

      {confirmedBids.length === 0 ? (
        <p className="text-center text-muted">No confirmed bids found.</p>
      ) : (
        <Row>
          {confirmedBids.map(({ seller_bid, bid_details, buyer_details }) => (
            <Col md={6} lg={4} key={seller_bid.id} className="mb-4">
<Card className="bid-card shadow-sm">
  <Card.Body>
    {/* Section 1: Bid & Product Details */}
    <div className="bid-details-section mb-4 pb-3 border-bottom">
      <h5 className="mb-3">
        <span className="fw-bold text-primary">🆔 Bid ID:</span> {seller_bid.bid_id}
      </h5>

      <div className="text-muted small">
        <div><strong>📦 Category:</strong> {bid_details.category} / {bid_details.sub_category}</div>
        <div><strong>💰 Price Range:</strong> ₹{bid_details.price_from} - ₹{bid_details.price_to}</div>
        <div><strong>🔧 Warranty:</strong> {bid_details.warranty}</div>
        <div><strong>🧩 Specs:</strong> {bid_details.selected_specs}</div>
        <div><strong>🕒 Created:</strong> {new Date(bid_details.created_at).toLocaleString()}</div>
      </div>
    </div>

    {/* Section 2: Your Offer */}
<div className="offer-section p-3 rounded bg-light shadow-sm">
  <h6 className="offer-title text-primary fw-bold mb-3">Your Offer</h6>
<ul className="list-unstyled small mb-3 offer-list">
  <li>
    <strong>Offer Price:</strong> <span className="offer-price">₹{seller_bid.seller_offer}</span>
  </li>
  <li>
    <strong>Status:</strong>{' '}
    <Badge bg={seller_bid.status === 'accepted' ? 'success' : 'secondary'}>
      {seller_bid.status}
    </Badge>
  </li>
  <li>
    <strong>Accepted At:</strong>{' '}
    {seller_bid.accepted_at ? new Date(seller_bid.accepted_at).toLocaleString() : 'N/A'}
  </li>

  {seller_bid.payment_status === 'paid' && Number(seller_bid.paid_amount_90per) > 0 ? (
    <li>
      <strong>Final Payment:</strong>{' '}
      <Badge bg="success">✅ 100% Paid</Badge>
    </li>
  ) : (
    <>
      <li><strong>Paid Amount (10%):</strong> ₹{seller_bid.paid_amount_10per}</li>
      <li><strong>Paid Amount (90%):</strong> ₹{seller_bid.paid_amount_90per}</li>
      <li>
        <strong>Payment Status:</strong>{' '}
        <Badge bg={seller_bid.payment_status === 'paid' ? 'success' : 'warning'}>
          {seller_bid.payment_status}
        </Badge>
      </li>
    </>
  )}
</ul>


  <Button
    variant="outline-primary"
    size="sm"
    className="offer-contact-btn"
    onClick={() => handleContactBuyer(buyer_details)}
  >
    📞 Contact Buyer
  </Button>
</div>

  </Card.Body>
</Card>

            </Col>
          ))}
        </Row>
      )}

      {/* Buyer Info Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title>👤 Buyer Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedBuyer && (
            <>
              <h5 className="text-primary">{selectedBuyer.name}</h5>
              <p><strong>Email:</strong> {selectedBuyer.email}</p>
              <p><strong>Mobile:</strong> {selectedBuyer.mobile}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
